import * as React from "react";
import styled from "styled-components";
import { IoMdClose } from "react-icons/io";
import { Col, Container, Row } from "react-grid-system";
import Card from "./Card";
import Loader from "../utils/Loader";

import mainStore from "../../store/index";
import ModalAmount from "./ModalAmount";

import groupBy from "lodash/groupBy";
import pilys from "./data/pilys";

interface Props {
  data: {
    name: string;
    description: string;
    items: any;
  };
  name: string;
  closeFullScreen: any;
  id_restaurant: any;
}

interface ItemInterface {
  amount: any;
  data: {
    name: string;
    description: string;
    items: any;
  };
}

const GroupedSections = (data_: any) => {
  const { data } = data_;

  return (
    <>
      {data && (
        <>
          {data.map((dt: any, index: any) => (
            <>
              <Card
                key={index}
                data={dt}
                type={"vertical"}
                handleAddItem={() => null}
                show_order={true}
              />
            </>
          ))}
        </>
      )}
    </>
  );
};

export default function FullScreen(props: Props) {
  const STORE = mainStore();

  const [loader, setLoader] = React.useState(false);

  const [openamount, setOpenAmount] = React.useState(false);
  const [productamount, setProductAmount] = React.useState<any>(null);

  const [dataGrouped, setDataGrouped] = React.useState<any>(null);
  const [isgrouped, setIsGrouped] = React.useState<boolean>(false);

  React.useEffect(() => {
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
    }, 200);

    if (props.id_restaurant === "YUZhlttU2aQmlS0UrHhI6MFQvw13") {
      setIsGrouped(true);
    } else {
      setIsGrouped(false);
    }

    getSections(props.data);
  }, []);

  const MENUS_DATA: any = props.data;

  const getSections = (MENUS_DATA: any) => {
    const platos = ordenarPlatos(MENUS_DATA);

    let newArrayPlatos: any = [];
    if (platos !== undefined) {
      Object.entries(platos).forEach(([key, value]: any) => {
        newArrayPlatos.push(value);
      });
    } else {
      newArrayPlatos = [];
    }

    if (props.id_restaurant === "YUZhlttU2aQmlS0UrHhI6MFQvw13") {
      setDataGrouped(newArrayPlatos);
    } else {
      setDataGrouped(newArrayPlatos);
    }
  };

  // ORDENAR SECCIONES
  const ordenarSections = (MENUS_DATA: any) => {
    let newdata = [];

    let grouped = groupBy(MENUS_DATA, function (car: any) {
      if (car) {
        let description = car.description.replace(/ /g, "");
        return description;
      }
    });

    for (let clave in grouped) {
      newdata.push(grouped[clave.replace(/ /g, "")]);
    }
    // VER ORDEN DE LOS PRODUCTOS DEL RESTAURANTE
    let OrdenSections: any = {
      datos: [],
      orden: [],
    };

    pilys.data.map((i) => {
      if (i.id === MENUS_DATA[0].id_section) {
        OrdenSections.datos.push(...i.datos);
        OrdenSections.orden.push(...i.orden);
      }
    });

    let productsSections: any = [];

    newdata.map((dt) => {
      let obs = {
        data: dt,
        id: dt[0].description.length <= 100 ? dt[0].description : null,
        order: null,
      };

      OrdenSections.datos.map((buf: any) => {
        if (buf.id === dt[0].description) {
          obs.order = buf.order;
        }
      });
      productsSections.push(obs);
    });

    let el: any = [];
    let ok = 0;
    newdata.map(() => {
      ok = 0 + el.push(ok);
    });

    let items = el.map((orden: any) => {
      return productsSections.find((x: any) => x.order === orden);
    });
    if (items.length === 0) items = productsSections;

    return items;
  };

  // ORDENAR PLATOS
  const ordenarPlatos = (MENUS_DATA: any) => {
    let newdata = MENUS_DATA;

    return newdata;

    // let el: any = [];
    // let ok = 0;

    // if (!newdata) return;

    // newdata.map(() => {
    //   ok = 0 + el.push(ok);
    // });

    // let items = el.map((orden: any) => {
    //   return newdata.find((x: any) => x.position === orden);
    // });

    // if (items[0] === undefined) {
    //   return newdata;
    // } else {
    //   return items;
    // }
  };

  const closeFullScreen = () => {
    props.closeFullScreen();
  };

  const handleAddItemComplete = (data_: ItemInterface, amount_: number) => {
    let obj = data_;
    obj.amount = amount_;

    calculateProducts();

    STORE.introduce_item(obj);
    setOpenAmount(false);
  };

  const calculateProducts = () => {};

  return (
    <ContentFullScreen>
      <header>
        <Container>
          <Row align="center">
            <Col xs={8}>
              <h4 className="pt-1">{props.name}</h4>
            </Col>
            <Col xs={4}>
              <button
                onClick={() => closeFullScreen()}
                className="btnclose bg-danger"
              >
                <IoMdClose /> Cerrar
              </button>
            </Col>
          </Row>
        </Container>
      </header>
      <section className="">
        {loader && (
          <div className="w-100 text-center">
            <Loader color="#3498db" />
          </div>
        )}

        {dataGrouped && <GroupedSections data={dataGrouped} />}

        {/* {MENUS_DATA && (
          <>
            {MENUS_DATA.length > 0 && (
              <>
                <GroupedSections data={dataGrouped} />
              </>
            )}
          </>
        )} */}
        <Container>
          {!MENUS_DATA && (
            <div className="text-center text-dark">
              <h4>Sin productos</h4>
            </div>
          )}
        </Container>
        {openamount && (
          <ModalAmount
            productamount={productamount}
            hanldeAddProduct={handleAddItemComplete}
          />
        )}
      </section>
    </ContentFullScreen>
  );
}
const ContentFullScreen = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  /* min-height: 100vh; */
  height: 100vh;
  background: white;
  overflow-y: auto;
  overflow-x: hidden;
  height: 100vh;
  z-index: 4;
  padding-bottom: 5em;
  header {
    width: 100%;
    position: fixed;
    top: 0;
    padding: 1em 0;
    background: white;
    border-bottom: 1px solid #ecf0f1;
    z-index: 1;
    color: #2c3e50;
    h4 {
      font-weight: bold;
    }
  }
  .btnclose {
    border: none;
    font-weight: bold;
    color: white;
    svg {
      font-size: 1.5em;
      margin-top: -5px;
    }
  }
  h2 {
    font-weight: bold;
    color: #2c3e50;
    letter-spacing: 2px;
  }
  background: #ffffff;

  section {
    display: block;
    position: relative;
    width: 100%;
    margin-top: 8em;
  }
`;
